export default function newsletterPopup() {
  const trigger = document.querySelector(".js-newsletter-popup-trigger");
  let triggered = false;

  if (!trigger) {
    return;
  }

  const newsletterPopup = document.querySelector(".js-newsletter-popup");
  const closeTriggers = document.querySelectorAll(".js-newsletter-popup-close");

  const callback = function(els) {
    els.forEach(el => {
      if (el.isIntersecting && triggered == false) {
        triggered = true;
        newsletterPopup.classList.replace('hidden', 'opacity-0');

        setTimeout(function() {
          newsletterPopup.classList.add('opacity-100');
        }, 200);
      }
    });
  }

  const observer = new IntersectionObserver(callback);
  observer.observe(trigger);

  closeTriggers.forEach(el => {
    el.addEventListener('click', function() {
      newsletterPopup.classList.add('hidden');
    });
  })

}
